import { Navigation, UrlUtil } from "@mcleod/core";
import { AutogenLayoutLocationList } from "./autogen/AutogenLayoutLocationList";
import { DataSourceExecutionEvent } from "@mcleod/components";
import { LocationToProspect } from "@mcleod/crm";

export class LocationList extends AutogenLayoutLocationList {
     override onLoad() {
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search)
        if (urlProp != null && urlProp.ids != null) {
            this.mainDataSource.search({ ids: urlProp.ids });
        }
    }
    
    buttonFindNearOnClick() {
        Navigation.navigateTo("lme/dispatch/LocationFindNear", { newTab: true });
    }

    buttonLocationToProspectOnClick() {
        LocationToProspect.showAsSlideout(this.mainDataSource.data, this.buttonLocationToProspect);
    }

    sourceLocationAfterExecution(event: DataSourceExecutionEvent) {
        this.buttonLocationToProspect.enabled = this.mainDataSource.rowCount > 0;
    }
}
